module.exports = __webpack_public_path__ + "static/img/invest-make1.85edd22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-make1.jpg
// module id = GtjH
// module chunks = 0